import { TimelineDotVariant } from "@/core/components/timeline";
import { PAYROLL_RUN_STATUS } from "@/payroll/constants";
import { PayrollRunStatus } from "@/payroll/payroll.d";

export const PAYROLL_RUN_STATUS_UI = {
  [PAYROLL_RUN_STATUS.deferred]: {
    badgeVariant: "blue" as const,
    label: "Processing",
    timelineDotVariant: "blue" as const,
  },
  [PAYROLL_RUN_STATUS.pending]: {
    badgeVariant: "gray" as const,
    label: "Pending",
    timelineDotVariant: "blue" as const,
  },
  [PAYROLL_RUN_STATUS.processing]: {
    badgeVariant: "blue" as const,
    label: "Processing",
    timelineDotVariant: "blue" as const,
  },
  [PAYROLL_RUN_STATUS.completed]: {
    badgeVariant: "green" as const,
    label: "Completed",
    timelineDotVariant: "green" as const,
  },
  [PAYROLL_RUN_STATUS.failed]: {
    badgeVariant: "destructive" as const,
    label: "Failed",
    timelineDotVariant: "destructive" as const,
  },
} satisfies Record<
  PayrollRunStatus,
  {
    badgeVariant: "blue" | "gray" | "green" | "destructive";
    label: string;
    timelineDotVariant: TimelineDotVariant;
  }
>;
